// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"GraficoSeguradorasFunil_tooltip__3Y21N","legendaPizza":"GraficoSeguradorasFunil_legendaPizza__3YkW8"};